import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="mb-4 font-heading text-2xl font-bold tracking-tight text-slate-900">Users</h1>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="w-full min-w-[500px] text-left text-sm">
          <thead className="bg-slate-50 text-slate-500"><tr><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Role</th><th className="p-3">Joined</th></tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-slate-100">
                <td className="p-3 font-medium text-slate-900">{u.name}</td>
                <td className="p-3 text-slate-500">{u.email}</td>
                <td className="p-3"><span className={`rounded-full px-2 py-0.5 text-xs font-medium capitalize ${u.role === "admin" ? "bg-red-50 text-red-600" : "bg-blue-50 text-blue-700"}`}>{u.role}</span></td>
                <td className="p-3 text-slate-400">{(u.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
